function isAndroidWebView() {
  const ua = window.navigator.userAgent || '';
  return /Android/i.test(ua) && /; wv\)/.test(ua);
}

// Home-screen, installed app, fullscreen, and Android WebView can draw under
// the status bar. A normal browser tab does not.
function isOverlayShell() {
  if (window.navigator.standalone === true) {
    return true;
  }
  if (isAndroidWebView()) {
    return true;
  }
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches
  );
}

export function syncSafeAreaInsets() {
  if (typeof document === 'undefined') {
    return;
  }

  const root = document.documentElement;
  ['top', 'bottom', 'left', 'right'].forEach((side) => {
    root.style.removeProperty(`--safe-area-${side}`);
  });
  root.setAttribute('data-safe-area-mode', isOverlayShell() ? 'overlay' : 'browser');
}

export function initSafeAreaInsets() {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const run = () => syncSafeAreaInsets();
  run();

  window.addEventListener('resize', run);
  window.addEventListener('orientationchange', run);
  window.addEventListener('pageshow', run);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', run);
  }

  return () => {
    window.removeEventListener('resize', run);
    window.removeEventListener('orientationchange', run);
    window.removeEventListener('pageshow', run);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', run);
    }
  };
}
